// extracted by mini-css-extract-plugin
module.exports = {"features":"features_features__Rbn2d","checkItem":"features_checkItem__sWf0j","title":"features_title__s9D06","icon":"features_icon__zoWln","label":"features_label__ZQRKz"};